import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AuthLayout from "../components/AuthLayout";
import api, { formatApiError } from "../lib/api";
import PasswordInput from "../components/PasswordInput";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const token = params.get("token") || "";
  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError("Passwords do not match."); return; }
    if (password.length < 12 || !/[a-z]/.test(password) || !/[A-Z]/.test(password) || !/[0-9]/.test(password)) {
      setError("Use at least 12 characters with uppercase, lowercase, and a number."); return;
    }
    setLoading(true); setError("");
    try { await api.post("/auth/password/reset", { token, password }); setDone(true); }
    catch (err) { setError(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return <AuthLayout>
    <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900">Choose a new password</h1>
    {done ? <div className="mt-8 border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800">Password updated. You can now sign in.</div> :
      <form onSubmit={submit} className="mt-8 space-y-4">
        <PasswordInput data-testid="reset-password-input" toggleTestId="reset-password-toggle"
                       autoComplete="new-password" minLength={12} maxLength={72} required value={password}
                       onChange={e=>setPassword(e.target.value)} placeholder="12+ characters, mixed case and number"
                       className="w-full border border-slate-300 bg-white px-3 py-2.5 text-sm outline-none focus:border-slate-900" />
        <PasswordInput data-testid="reset-password-confirm-input" toggleTestId="reset-password-confirm-toggle"
                       autoComplete="new-password" minLength={12} maxLength={72} required value={confirm}
                       onChange={e=>setConfirm(e.target.value)} placeholder="Confirm password"
                       className="w-full border border-slate-300 bg-white px-3 py-2.5 text-sm outline-none focus:border-slate-900" />
        {error && <p className="text-sm text-red-600">{error}</p>}
        <button disabled={loading || !token} className="w-full bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white disabled:opacity-60">{loading ? "Updating…" : "Update password"}</button>
      </form>}
    <Link to="/login" className="mt-6 block text-sm font-medium text-slate-700 underline underline-offset-2">Back to sign in</Link>
  </AuthLayout>;
}
